import { render, staticRenderFns } from "./referrer-note-tab.vue?vue&type=template&id=f8deb374"
import script from "./referrer-note-tab.vue?vue&type=script&lang=js"
export * from "./referrer-note-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports